import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiCall } from '../api';
import ForgotPasswordModal from '../components/ForgotPasswordModal';
import '../styles/Login.css';

const Login = ({ onLogin }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const data = await apiCall('/api/auth/login', {
        method: 'POST',
        body: JSON.stringify({ email, password })
      });

      // Store authentication token and user data in localStorage
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));

      // Determine redirect path based on pipeline and user email
      // This ensures we navigate to the correct path before React re-renders
      const pipeline = data.user.pipeline || 'all';
      const userEmail = data.user.email?.toLowerCase() || '';
      const userRole = data.user.role || 'user';
      
      let redirectPath = '/dashboard';
      
      // Route based on pipeline - admin goes to main dashboard like other users
      if (pipeline === 'v1') {
        redirectPath = '/v1/dashboard';
      } else if (pipeline === 'cocb') {
        redirectPath = '/v1/cocb/dashboard';
      } else if (pipeline === 'gfs') {
        redirectPath = '/gfs/dashboard';
      } else if (pipeline === 'sip') {
        redirectPath = '/sip/dashboard';
      } else if (pipeline === 'cob') {
        redirectPath = '/cob/dashboard';
      } else if (pipeline === 'multi-amc') {
        redirectPath = '/multi-amc/dashboard';
      } else if (pipeline === 'sip-otm') {
        redirectPath = '/sip-otm/dashboard';
      }
      console.log('[Login] User pipeline:', pipeline, 'Role:', userRole, 'Redirecting to:', redirectPath);

      // Call onLogin callback to update app state
      if (onLogin) {
        onLogin(data.user);
      }

      // Navigate to the appropriate dashboard
      navigate(redirectPath, { replace: true });
    } catch (err) {
      setError(err.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      {/* Left Panel - Branding */}
      <div className="login-panel login-panel-left">
        <div className="login-branding">
          <div className="login-logo">
            <div className="logo-icon">📋</div>
          </div>
          <h1>KFintech OCR</h1>
          <p>Intelligent Document Recognition Platform</p>

          <div className="login-features">
            <div className="feature">
              <span className="feature-icon">✨</span>
              <span>Advanced OCR & ICR Technology</span>
            </div>
            <div className="feature">
              <span className="feature-icon">⚡</span>
              <span>Fast & Accurate Extraction</span>
            </div>
            <div className="feature">
              <span className="feature-icon">🔒</span>
              <span>Enterprise Security</span>
            </div>
            <div className="feature">
              <span className="feature-icon">📊</span>
              <span>Real-time Analytics</span>
            </div>
          </div>
        </div>
      </div>

      {/* Right Panel - Login Form */}
      <div className="login-panel login-panel-right">
        <div className="login-form-wrapper" style={{maxWidth: '100%'}}>
          <div className="login-form-header">
            <h2>Welcome Back</h2>
            <p>Sign in to your account to continue</p>
          </div>

          {error && (
            <div className="login-alert alert alert-error">
              <span className="alert-icon">⚠️</span>
              <div className="alert-content">
                <div className="alert-title">Login Error</div>
                <p>{error}</p>
              </div>
            </div>
          )}

          <form onSubmit={handleLogin} className="login-form">
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                id="email"
                type="email"
                placeholder="you@company.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={loading}
              />
            </div>

            <div className="login-options">
              <div></div>
              <button
                type="button"
                className="forgot-link"
                onClick={() => setShowForgotPassword(true)}
              >
                Forgot password?
              </button>
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-lg btn-block"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-mini"></span>
                  Signing in...
                </>
              ) : (
                'Sign In'
              )}
            </button>
          </form>

          <div className="login-footer">
            <p>Don't have an account? <a href="#admin">Contact administrator</a></p>
          </div>
        </div>
      </div>

      <ForgotPasswordModal
        isOpen={showForgotPassword}
        onClose={() => setShowForgotPassword(false)}
      />
    </div>
  );
};

export default Login;
